<template>
	<el-dialog :close-on-click-modal="false" append-to-body :title="isEdit ? '编辑模板页' : '新建模板页'" :visible.sync="addMustDialog" @closed="addModuleClosed" width="750px">
		<el-form ref="addModuleForm" :model="addModuleVo" :rules="addMofuleRules" label-width="130px">
			<el-form-item label="模板页名称:" prop="name" v-show="step === 1">
				<el-input v-model="addModuleVo.name" :disabled="isEdit" style="width:200px;" clearable></el-input>
			</el-form-item>
			<el-form-item label="是否关联设计版:" v-show="step === 1">
				<el-switch clearable v-model="addModuleVo.isAssociatedePtsTemplate" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"></el-switch>
			</el-form-item>
			<el-form-item label="尺寸:" prop="size" inline-message v-show="step === 1 && addModuleVo.isAssociatedePtsTemplate">
				<el-button type="primary" @click="$refs.selectSize.show(), (Parr = []), (addModuleVo.attribute = '')" round>选择尺寸</el-button>
				<span v-show="addModuleVo.composeSizeId">已选择尺寸：{{ addModuleVo.sizeName }}</span>
			</el-form-item>
			<el-form-item label="模板性质:" prop="attribute" inline-message v-show="step === 1 && addModuleVo.isAssociatedePtsTemplate">
				<el-radio-group v-model="addModuleVo.attribute" size="small">
					<!-- <el-radio-button label="1">半批</el-radio-button>
          <el-radio-button label="2">整批</el-radio-button> -->
					<el-radio-button v-for="(item, i) in Parr" :key="i" :label="item === '半批' ? 1 : 2">{{ item }}</el-radio-button>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="页面类型:" prop="pageTypeCode" inline-message v-show="step === 1 && addModuleVo.isAssociatedePtsTemplate">
				<span v-show="addModuleVo.pageTypeCode">{{ $store.state.pms.pageType[addModuleVo.pageTypeCode] }}</span>
			</el-form-item>
			<el-form-item label="模板页类型:" prop="role" v-show="step === 1 && addModuleVo.isAssociatedePtsTemplate">
				<el-select v-model="addModuleVo.attrId" placeholder="请选择">
					<el-option v-for="item in role" :key="item.attrId" :label="item.attrName" :value="item.attrId"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="模板页信息:" prop="list" v-show="step === 2">
				<div v-show="!isEdit">
					<el-button type="primary" @click="selectModuleInfoDialog = true" round>添加</el-button>
					<el-button type="primary" @click="$refs.addModuleInfo.show()" round>新建</el-button>
					<span style="color: red;margin-left: 18px;">拖动可对模板页调序</span>
				</div>
				<el-table :data="selectedInfoList" ref="selectmoduleInfoList" row-key="infoId" class="dragModuleInfo" border style="width: 600px;margin: 10px 0;">
					<el-table-column prop="name" label="模板页信息"></el-table-column>
					<el-table-column prop="infoType" label="类型">
						<template slot-scope="scope">
							<span v-if="scope.row.infoType === 'TEXT'">文本</span>
							<span v-if="scope.row.infoType === 'IMAGE'">图片</span>
						</template>
					</el-table-column>
					<el-table-column prop="infoValue" label="限制" width="200px">
						<template slot-scope="scope">
							<div class="infoValue" v-if="scope.row.infoType === 'TEXT'"> 文本长度： <el-input v-model="scope.row.textValue" :disabled="isEdit"></el-input>
							</div>
							<div class="infoValue" v-if="scope.row.infoType === 'IMAGE'"> 数量: <el-input v-model="scope.row.imageValueStart" :disabled="isEdit"></el-input> - <el-input
									v-model="scope.row.imageValueEnd" :disabled="isEdit"></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="模板页内容" prop="content" v-show="addModuleVo.isAssociatedePtsTemplate"></el-table-column>
					<el-table-column label="操作" v-show="!isEdit">
						<template slot-scope="scope">
							<span class="action_btn" @click="moduleInfoRemoveList(scope)">移除</span>
						</template>
					</el-table-column>
				</el-table>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" round v-show="step === 1" @click="toStep2()">下一步</el-button>
			<el-button type="primary" round v-show="step === 2" @click="step = 1">上一步</el-button>
			<el-button type="primary" round v-show="step === 2" @click="addModule">确 定</el-button>
		</span>
		<el-dialog :close-on-click-modal="false" width="600px" title="选择模板页信息" :visible.sync="selectModuleInfoDialog" append-to-body>
			<el-table :data="moduleInfoList" ref="moduleInfoList" row-key="infoId" class="table-cell" border style="width: 600px;margin: 10px 0;" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55" reserve-selection></el-table-column>
				<el-table-column prop="name" label="模板页信息"></el-table-column>
				<el-table-column prop="infoType" label="类型">
					<template slot-scope="scope">
						<span v-if="scope.row.infoType === 'TEXT'">文本</span>
						<span v-if="scope.row.infoType === 'IMAGE'">图片</span>
					</template>
				</el-table-column>
				<el-table-column prop="infoValue" label="限制" width="200px"></el-table-column>
				<el-table-column label="模板页内容" prop="content"></el-table-column>
			</el-table>
			<div class="vm-pagination">
				<v-pagination class="v-pagination" :queryInfo="moduleInfoQueryInfo" @changePage="changePage"></v-pagination>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="selectedInfo()">确 定</el-button>
			</span>
		</el-dialog>
		<add ref="addModuleInfo" @success="getModuleInfoList" />
		<selectSize ref="selectSize" @selected="selectedSize" />
	</el-dialog>
</template>

<script>
import VPagination from '@/components/Pagination/index.vue'
import selectSize from './selectSize.vue'
import add from '../moduleInfo/add.vue'
import Sortable from 'sortablejs'
import { moduleInfoPage, adminModuleAttributeList, moduleAdd, moduleCheckName } from '@/api/auxx.js'

export default {
	name: 'addModuleDialog',
	components: {
		add,
		selectSize,
		VPagination
	},
	data () {
		var list = (rule, value, callback) => {
			console.log(this.selectedInfoList)
			if (this.selectedInfoList.length === 0) {
				callback(new Error('请选择模板页信息'))
			} else {
				let lock = false
				let imgLock = false
				let imgNum = 0

				this.selectedInfoList.some(item => {
					if (item.infoType === 'IMAGE') {
						imgNum++
					}
					if (item.infoType === 'TEXT' && item.textValue && !/[^\d]/g.test(item.textValue)) {
					} else if (
						item.infoType === 'IMAGE' &&
						item.imageValueStart &&
						!/[^\d]/g.test(item.imageValueStart) &&
						item.imageValueEnd &&
						!/[^\d]/g.test(item.imageValueEnd)
					) {
						if (+item.imageValueStart > +item.imageValueEnd) {
							imgLock = true
						}
					} else {
						lock = true
					}
				})

				if (lock) {
					callback(new Error('请输入限制，格式为整数'))
				} else if (imgLock) {
					callback(new Error('最大图片数不能小于最小图片数'))
				} else if (imgNum > 1) {
					callback(new Error('只能选一组图片'))
				} else {
					callback()
				}
			}
		}
		var attribute = (rule, value, callback) => {
			if (this.addModuleVo.isAssociatedePtsTemplate && !this.addModuleVo.attribute) {
				callback(new Error('请选择模板性质'))
			} else {
				callback()
			}
		}
		var size = (rule, value, callback) => {
			if (this.addModuleVo.isAssociatedePtsTemplate && !this.addModuleVo.composeSizeId) {
				callback(new Error('请选择尺寸'))
			} else {
				callback()
			}
		}
		var role = (rule, value, callback) => {
			if (this.addModuleVo.isAssociatedePtsTemplate && !this.addModuleVo.attrId) {
				callback(new Error('请选择类型'))
			} else {
				callback()
			}
		}
		var pageTypeCode = (rule, value, callback) => {
			if (this.addModuleVo.isAssociatedePtsTemplate && !this.addModuleVo.attrId) {
				callback(new Error('请选择尺寸类型'))
			} else {
				callback()
			}
		}
		return {
			Parr: [],
			step: 1,
			selectedModuleInfo: [],
			selectedInfoList: [],
			isEdit: false,
			editScope: {},
			templateVo: {
				attachType: 'HQ',
				modulees: [],
				name: '',
				storeId: this.$store.state.user.storeId
			},
			addModuleVo: {
				isAssociatedePtsTemplate: false,
				composeSizeId: '',
				sizeName: '',
				name: '',
				attrId: '',
				attribute: '',
				pageTypeCode: ''
			},
			moduleInfoQueryInfo: {
				total: 0,
				pageSize: 10,
				pageNum: 1
			},
			selectModuleInfoDialog: false,
			selectModuleInfo: null,
			selectModuleInfoList: [],
			moduleInfoList: [],
			selectModuleList: [],
			addModuleInfoDialog: false,
			addMustDialog: false,
			form: {},
			addMofuleRules: {
				name: [{ required: true, message: '请输入模板页名称', trigger: 'blur' }, { max: 20, message: '长度20个字以内', trigger: 'blur' }],
				attribute: [{ validator: attribute, trigger: 'blur' }],
				size: [{ validator: size, trigger: 'blur' }],
				role: [{ validator: role, trigger: 'blur' }],
				list: [{ validator: list, trigger: 'blur' }],
				pageTypeCode: [{ validator: pageTypeCode, trigger: 'blur' }]
			},
			role: []
		}
	},
	created () {
		this.getRole()
	},
	methods: {
		changePage (val) {
			console.log(val)
			this.moduleInfoQueryInfo = val
			this.getModuleInfoList(this.moduleInfoQueryInfo)
		},
		toStep2 () {
			let lock = ''
			this.$refs.addModuleForm.validateField(['name', 'size', 'role', 'attribute'], e => {
				lock += e
			})
			if (!lock) {
				moduleCheckName({
					act: 0,
					name: this.addModuleVo.name
				}).then(res => {
					if (res.data.success) {
						this.step = 2
						this.getModuleInfoList()
					} else {
						this.addModuleVo.name = ''
					}
				})
			}
		},
		getRole () {
			adminModuleAttributeList().then(res => {
				if (res.data.success) {
					this.role = res.data.data
				}
			})
		},
		selectedSize (info) {
			console.log(info, 'sjliuhfuhow')
			this.addModuleVo.sizeName = info.sizeName
			this.addModuleVo.composeSizeId = info.id
			this.addModuleVo.pageTypeCode = info.pageTypeCode
			this.Parr = []
			if (info.spuPageName.templateProperty.indexOf(',') === -1) {
				this.Parr.push(info.spuPageName.templateProperty)
			} else {
				info.spuPageName.templateProperty.split(',').forEach(i => {
					this.Parr.push(i)
				})
			}
			this.Parr = [...new Set(this.Parr)]
			if (this.Parr.length === 1 && this.Parr.includes('整批')) this.addModuleVo.attribute = 2
			else if (this.Parr.length === 1 && !this.Parr.includes('整批')) this.addModuleVo.attribute = 1
			console.log('ParrParrParr', this.Parr)
		},
		selectedInfo () {
			console.log(this.selectedModuleInfo, this.selectedInfoList, this.moduleInfoList)
			this.selectedModuleInfo.forEach(module => {
				if (
					!this.selectedInfoList.some(item => {
						return item.infoId === module.infoId
					})
				) {
					this.selectedInfoList.push(module)
				}
			})
			// this.selectedInfoList.push(...this.selectedModuleInfo)
			this.$refs.moduleInfoList.clearSelection()
			this.selectModuleInfoDialog = false
			this.$refs.addModuleForm.validateField('list')
		},
		handleSelectionChange (val) {
			console.log(val)
			this.selectedModuleInfo = val
			console.log('this.selectedModuleInfo', this.selectedModuleInfo)
		},
		show (type, scope) {
			this.isEdit = type
			if (type) {
				this.editScope = scope
				this.editModule(scope)
			}
			this.addMustDialog = true
			this.$nextTick(_ => {
				this.drag()
			})
		},
		drag () {
			let el = document.getElementsByClassName('dragModuleInfo')[0].querySelectorAll('tbody')[0]
			console.log(el)
			Sortable.create(el, {
				disabled: false, // 是否开启拖拽
				ghostClass: 'sortable-ghost', // 拖拽样式
				animation: 150, // 拖拽延时，效果更好看
				group: {
					// 是否开启跨表拖拽
					pull: false,
					put: false
				},
				onEnd: e => {
					// 这里主要进行数据的处理，拖拽实际并不会改变绑定数据的顺序，这里需要自己做数据的顺序更改
					let list = this.selectedInfoList
					list.splice(e.newIndex, 0, list.splice(e.oldIndex, 1)[0])
					this.$nextTick(_ => {
						this.selectedInfoList = list
					})
				}
			})
		},
		editModule (scope) {
			let list = JSON.parse(JSON.stringify(scope.row.moduleInfoXrefs))

			let indexList = []
			list.forEach(info => {
				info.name = info.refInfo.name
				if (info.infoType === 'TEXT') {
					info.textValue = info.infoValue
				} else if (info.infoType === 'IMAGE') {
					info.imageValueStart = info.infoValue.split('-')[0]
					info.imageValueEnd = info.infoValue.split('-')[1]
				}
				let index = this.moduleInfoList.findIndex(item => item.infoId === info.infoId)
				indexList.push(index)
				this.moduleInfoList[index] = info
			})

			this.selectedInfoList = list

			this.addModuleVo = JSON.parse(JSON.stringify(scope.row))
		},
		selectModule () {
			this.templateVo.modulees = this.selectModuleList
			this.$refs.templateForm.validateField('modulees')
		},
		addModuleClosed () {
			this.step = 1
			this.addModuleVo.name = ''
			this.selectModuleInfoList.length = 0
			this.selectedInfoList.length = 0
			this.selectModuleInfo = ''
			this.$refs.addModuleForm.clearValidate()
		},
		addModule () {
			console.log('进入')
			this.$refs.addModuleForm.validate(valid => {
				if (!valid) {
					return
				}
				console.log('进入22')

				let addModuleVo = {
					attachType: 'HQ',
					moduleInfoVos: [],
					isAssociatedePtsTemplate: this.addModuleVo.isAssociatedePtsTemplate,
					composeSizeId: this.addModuleVo.composeSizeId,
					sizeName: this.addModuleVo.sizeName,
					attrId: this.addModuleVo.attrId,
					attribute: this.addModuleVo.attribute,
					name: this.addModuleVo.name,
					storeId: this.$store.state.user.storeId,
					pageTypeCode: this.addModuleVo.pageTypeCode
				}

				if (
					this.selectedModuleInfo.some(item => {
						let lock = false
						if (item.infoType === 'TEXT' && /[^\d]/g.test(item.textValue)) {
							lock = true
						} else if (
							item.infoType === 'IMAGE' &&
							item.imageValueStart &&
							/[^\d]/g.test(item.imageValueStart) &&
							item.imageValueEnd &&
							/[^\d]/g.test(item.imageValueEnd)
						) {
							lock = true
						}
						return lock
					})
				) {
					this.$message.error('模板页信息限制数据有误，应为非负整数，请检查后重试')
					return
				}
				console.log('进入333')

				addModuleVo.moduleInfoVos = this.selectedInfoList.reduce((list, item) => {
					let infoValue = ''
					if (item.infoType === 'TEXT') {
						infoValue = item.textValue
					} else if (item.infoType === 'IMAGE') {
						infoValue = item.imageValueStart + '-' + item.imageValueEnd
					}

					let obj = {
						defaultChange: infoValue !== item.infoValue,
						infoId: item.infoId,
						infoType: item.infoType,
						infoValue,
						sorting: list.length + 1
					}
					list.push(obj)
					return list
				}, [])
				console.log(this.selectedInfoList, addModuleVo, 'sfhefiuheqw')

				if (this.isEdit) {
					this.addMustDialog = false
				} else {
					moduleAdd(addModuleVo).then(res => {
						if (res.data.success) {
							this.$emit('success')
							this.$message.success('新建成功')
							this.addMustDialog = false
							this.addModuleVo = {
								isAssociatedePtsTemplate: false,
								composeSizeId: '',
								sizeName: '',
								name: '',
								attrId: '',
								attribute: '',
								pageTypeCode: ''
							}
						}
					})
				}
			})
		},
		moduleInfoRemoveList (scope) {
			this.selectedInfoList.splice(scope.$index, 1)
			this.$refs.addModuleForm.validateField('list')
		},
		getModuleInfoList (val) {
			console.log(val)
			moduleInfoPage({
				data: this.addModuleVo,
				params: { page: this.moduleInfoQueryInfo.pageNum - 1, size: this.moduleInfoQueryInfo.pageSize },
				// vo: { name: val, isAssociatedePtsTemplate: this.addModuleVo.isAssociatedePtsTemplate }

				// 原有代码
				// vo: { isAssociatedePtsTemplate: this.addModuleVo.isAssociatedePtsTemplate }
				// 修改后的
				vo: {}
			}).then(res => {
				if (res.data.success) {
					console.log(res.data.data)
					this.moduleInfoQueryInfo.total = res.data.data.total
					let list = res.data.data.content
					list.forEach(obj => {
						if (obj.infoType === 'TEXT') {
							obj.textValue = obj.infoValue
						} else if (obj.infoType === 'IMAGE') {
							obj.imageValueStart = obj.infoValue.split('-')[0]
							obj.imageValueEnd = obj.infoValue.split('-')[1]
						}
					})
					this.moduleInfoList = list
					console.log('this.moduleInfoList', this.moduleInfoList)
					if (this.isEdit) {
						this.editModule(this.editScope)
					}
				}
			})
		}
	}
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';

.infoValue {
	@{deep} .el-input {
		width: 40px;

		input {
			padding: 0 2px;
			text-align: center;
		}
	}
}

.action_btn {
	display: block;
	width: 70px;
	height: 22px;
	border-radius: 22px;
	background: #f2f2f2;
	border: 1px solid #cccccc;
	font-size: 12px;
	font-family: Source Han Sans CN, Source Han Sans CN-Light;
	font-weight: 300;
	text-align: center;
	color: #2e7cd4;
	margin: 5px auto;
	cursor: pointer;
}

/deep/ .el-radio-button__inner:hover {
	color: #1473e6;
}

/deep/.el-radio-button,
/deep/.el-radio-button__inner {
	width: 60px !important;
	border-radius: 20px !important;
	box-shadow: none !important;
	margin-right: 10px;
}
</style>
